import React from "react";
import DropDownOptions, { DropDownOption } from "../constants/dropDownOptions";
import { Dropdown, DropdownMenuItemType, IDropdownOption, IDropdownStyles } from '@fluentui/react/lib/Dropdown';

const dropdownStyles: Partial<IDropdownStyles> = { dropdown: { width: 300 } };

interface IOption {
    key: string,
    text: string,
    itemType?: DropdownMenuItemType,
}

const createDropDownOptions = (options: DropDownOption[]): IOption[] => (
    options.map((option) => (
        typeof option === 'string'
            ? { key: option, text: option }
            : { key: option.key, text: option.label }
    ))
);

// option id -> list name in DropDownOptions; ids not listed use their own name, unknown ones fall back to 'default'
const OPTION_TYPES: Record<string, string> = {
    bubbleBorderStyle: 'borderStyles',
    bubbleFromUserBorderStyle: 'borderStyles',
    suggestedActionBorderStyle: 'borderStyles',
    suggestedActionDisabledBorderStyle: 'borderStyles',
    monospaceFont: 'fonts',
    primaryFont: 'fonts',
    messageActivityWordBreak: 'wordBreak',
    bubbleFromUserNubOffset: 'bubbleNubOffset',
    theme: 'voiceTheme',
    animation: 'voiceAnimation',
    outboundPrepareAnimation: 'voiceOutboundPrepareAnimation',
    outboundCallingAnimation: 'voiceOutboundCallingAnimation',
    avatarSnippetToChatOnClose: 'avatarSnippetToChatOnClose',
    voiceSnippetToChatOnClose: 'voiceSnippetToChatOnClose',
    snippetExperience: 'snippetExperience',
};

const retrieveOptionType = (id: string): string =>
    OPTION_TYPES[id] || (id in DropDownOptions ? id : 'default');

interface DefaultSelectorProps {
    id: string;
    value: any;
    onChange: (styleElementName: string, value: any) => void;
}

export const DropDownSelector = (props: DefaultSelectorProps) => {
    const {id, value, onChange } = props;
    const [selectedItem, setSelectedItem] = React.useState<IDropdownOption>();
    
    const setValue = (
            event: React.FormEvent<HTMLDivElement>,
            option?: IDropdownOption | undefined,
            index?: number | undefined
        ): void => {
            let toSetValue: any = option?.key;
            if(toSetValue === "off") {
                toSetValue = false;
            }
            onChange(id, toSetValue);
            setSelectedItem(option);
    };

    const optionType: string = retrieveOptionType(id);
    // console.log(id);
    // console.log(optionType);
    // console.log(' ');
    
    const dropDownOptions: IOption[] = createDropDownOptions(DropDownOptions[optionType]);
    
    const savedKey = value === false ? "off" : value;
    const savedLabel = dropDownOptions.find(option => option.key === savedKey)?.text ?? savedKey;

    // (selectedItem.key as any === false ? "off": selectedItem.key)
    return (
       <Dropdown
            selectedKey={selectedItem ? (selectedItem.key as any === false ? "off": selectedItem.key) : undefined}
            onChange={setValue}
            // defaultValue={value === false ? "off": value}
            placeholder={savedLabel}
            options={dropDownOptions}
            styles={dropdownStyles}
        />
    );
};
